import OKIcon from './component'

export default OKIcon
